import React from "react";
import { Badge, Table, Card, CardHeader, CardTitle } from "reactstrap";
import 'components/LM/InstagramSearch/InstagramSearch.scss';
import ExportCSV from "components/LM/common/ExportCSV";
import ProxyImage from "components/LM/common/ProxyImage";
import Breadcrumb from "components/LM/common/Breadcrumb";

const CSV_COLUMNS = [
  {
    id: 'screenName',
    displayName: 'Screen name'
  },
  {
    id: 'profileUrl',
    displayName: 'Url'
  },
  {
    id: 'api',
    displayName: 'In the API?'
  },
  {
    id: 'profileName',
    displayName: 'Profile name'
  },
  {
    id: 'profileFollowers',
    displayName: 'Profile followers'
  },
  {
    id: 'profileId',
    displayName: 'Profile ID'
  },
  {
    id: 'coverage',
    displayName: 'In our Coverage list?'
  },
  {
    id: 'voiceId',
    displayName: 'Voice ID'
  },
  {
    id: 'voiceName',
    displayName: 'Voice name'
  }
];

function InstagramResults({ location }) {

  const results = location.state && location.state.results ? location.state.results : [];
  if (!results) return null;

  return (
    <div id="instagramSearch">
      <div className="instagram-search-results">
        <Breadcrumb items={['Instagram Search Result']} />
        <Card>
          <CardHeader>
            <CardTitle tag="h5">
              Results
              <ExportCSV columns={CSV_COLUMNS} datas={parseResultsToCsv(results)} filename="InstagramProfilesReport" buttonText="Download results in CSV" />
            </CardTitle>
            <h6 className="card-subtitle text-muted">Note that is not possible to provide the name & followers of the screen names not available in the API.</h6>
          </CardHeader>
          <ProfilesTable profiles={results} />
        </Card>
      </div>
    </div>
  )
}

function parseResultsToCsv(results) {
  let arrayRows = [];

  arrayRows = results.map(function (result) {
    let row;
    if (result.valid_screen_name && !result.reason) {
      row = {
        screenName: result.screen_name,
        profileUrl: result.url_profile,
        api: result.available_to_capture,
        profileName: result.full_name,
        profileFollowers: result.followers,
        profileId: result.id,
        coverage: result.crawling_list,
        voiceId: result.voices.map(o => o.id),
        voiceName: result.voices.map(o => o.name)
      };
    }
    else {
      row = {
        screenName: result.screen_name
      }
    }
    return row;
  })
  return arrayRows;
}

function YesBadge() {
  return (<Badge pill color="success">yes</Badge>)
}

function NoBadge() {
  return (<Badge pill color="danger">no</Badge>)
}

function ProfilesTable(props) {
  const { profiles } = props;

  if (!profiles) return null;

  return (
    <Table striped hover id="instagramSearchResultsDisplay">
      <thead>
        <tr>
          <th>Screen name</th>
          <th>In the API?</th>
          <th>Name & followers</th>
          <th>In our crawling list?</th>
          <th>Voice</th>
        </tr>
      </thead>
      <tbody>
        {profiles.map((profile, key) =>
          <tr key={key}>
            {profile.valid_screen_name && !profile.reason ? (
              <Profile
                id={profile.id}
                screenName={profile.screen_name}
                available={profile.available_to_capture}
                pictureUrl={profile.profile_picture_url}
                fullName={profile.full_name}
                followers={profile.followers}
                crawlingList={profile.crawling_list}
                voices={profile.voices}
              />
            ) : (
              <>
                <td><b>url</b>: {profile.url_profile}</td>
                <td colSpan="5">{profile.reason ? profile.reason : 'Invalid url profile!'}</td>
              </>
            )}
          </tr>
        )}
      </tbody>
    </Table>
  );
}

function Profile(props) {
  const { id, screenName, available, pictureUrl, fullName, followers, crawlingList, voices } = props;

  return (
    <>
      <td>@{screenName}</td>
      <td>{available ? <><YesBadge /><LinkExploreProfile screenName={screenName} /></> : <NoBadge />}</td>
      <td>{available ?
        <span><ProxyImage src={pictureUrl} className="rounded-circle mr-2 profile-image" alt={`${fullName} avatar`} />{fullName} - {followers} followers</span> : ''}
      </td>
      <td>
        {crawlingList ? <><YesBadge /><LinkInfoProfile id={id} /></> : <NoBadge />}
      </td>
      <td>
        {voices.map(s => <React.Fragment key={s.id}><a href={`/voices/${s.id}`} target='_blank' rel='noopener noreferrer'>{s.name}</a><br /></React.Fragment>)}
      </td>
    </>
  );
}

function LinkExploreProfile({ screenName }) {
  return <>[<a href={`/instagram/explore/${screenName}`} target='_blank' rel='noopener noreferrer'> + explore </a>]</>;
}

function LinkInfoProfile({ id }) {
  return <>[<a href={`/instagram/profile?id=${id}`} target='_blank' rel='noopener noreferrer'> + info </a>]</>
}

export default InstagramResults;
